import MBox from '@material-ui/core/Box';
import { useGoogleMap } from '@react-google-maps/api';
import MapControls from './MapControls';
import React, { useEffect, useState } from 'react';
import BoxMarker from './BoxMarker';
import { BOX_LIST_WIDTH } from 'home/Home';
import { Box } from 'home/useBoxes';
import { useRain } from './useRain';
import { RainLegend } from './RainLegend';
import { useEQs } from './useEQ';
import { EQMarker } from './EQMarker';
import { EQRange } from './EQRange';

interface Props {
  boxes: Box[];
  boxBounds: google.maps.LatLngBounds;
}

export const JP_CENTER: google.maps.LatLngLiteral = {
  lat: 38.04370631570389,
  lng: 137.25945649999997,
};
const DEFAULT_ZOOM = 6;

const MapContent = ({ boxes, boxBounds }: Props) => {
  const map = useGoogleMap();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (isFirstLoad) {
      if (boxes.length > 0) {
        map?.fitBounds(boxBounds);
      } else {
        map?.setCenter(JP_CENTER);
        map?.setZoom(DEFAULT_ZOOM);
      }
      setIsFirstLoad(false);
    }
  }, [map, boxes, boxBounds, isFirstLoad]);

  const { toggleRain, isShow, time } = useRain();

  const {
    eqData,
    isEqShow,
    toggleEqShow,
    onMinScaleChange,
    minScale,
  } = useEQs();

  return (
    <>
      {isShow ? (
        <MBox
          position="absolute"
          top={100}
          left={10}
          boxShadow="rgba(0, 0, 0, 0.3) 0px 1px 4px -1px"
          borderRadius="2px"
        >
          <RainLegend time={time} />
        </MBox>
      ) : null}
      {isEqShow ? (
        <>
          <MBox
            position="absolute"
            top={400}
            left={10}
            boxShadow="rgba(0, 0, 0, 0.3) 0px 1px 4px -1px"
            borderRadius="2px"
          >
            <EQRange minScale={minScale} onMinScaleChange={onMinScaleChange} />
          </MBox>
          {eqData?.map((data) => (
            <EQMarker data={data} key={data.id} />
          ))}
        </>
      ) : null}
      {boxes.map((box) => (
        <BoxMarker key={box.id} box={box} />
      ))}
      <MBox position="fixed" margin={1} top={0} right={BOX_LIST_WIDTH}>
        <MapControls
          boxCount={boxes.length}
          boxBounds={boxBounds}
          toggleRain={toggleRain}
          isRainShow={isShow}
          toggleEqShow={toggleEqShow}
          isEqShow={isEqShow}
        />
      </MBox>
    </>
  );
};

export default MapContent;
